class ResourceList {
	constructor(container) {
		this._container = ge(container);
		this._resources = [];
		this._activeItem = null;

		this.orderBy = ge('order-by');
		this.searchText = ge('search-text');
		this.filters = new FilterList();

		this.filters.addGroup('Sources', 'source', new Sources('resources'));
		this.filters.addGroup('Tags', 'tag', tags);

		onEv(this.orderBy, 'change', this.getList.bind(this));
		onEv(this.searchText, 'keyup paste', this.getList.bind(this));

		this.emptyState = null;
		onEv(document, 'primaryDataInvalid filterSelected', this.getList.bind(this));
		this.getList();
	}

	getList() {
		API.get(
			`items?order=${this.orderBy.value}` + 
			(this.searchText.value !== '' ? '&search=' + encodeURI(this.searchText.value) : '' ) +
			this.filters.toString
		)
		.then(json => {
			if (showError(json)) return;
			this._container.innerHTML = '';
			this._resources = [];

			if (json.resources && Array.isArray(json.resources)) {
				if (this.emptyState !== null) this.emptyState.remove();
				if (json.resources.length == 0) {
					this._container.appendChild(this.emptyState = div('no-content', [
					htm('h2', null, _("More empty space, to be replaced!")),
						img(null, '/images/space/planet.png'),
						p(null, [
							// btn('btn', img(null, '/images/space/video-btn.png'), {
							// 	'click': () => pageFlow.fromStart(2)
							// }),
							btn('btn', img(null, '/images/space/guide-btn.png'), {
								'click': () => pageFlow.fromStart(8)
							})
						])
					]));
				}
				json.resources.forEach(data => {
					let resource = Resource.fromArray(data, this);
					this._resources.push(resource);
					this._container.appendChild(resource.elem);
				});
				document.dispatchEvent(new Event('primaryDataLoaded'));
			}
		});
	}
}